<template>
    <div class="widget-suggestion widget card" v-if="suggestedProducts != ''">
        <header class="card-header">
            <h3 class="card-title">پیشنهاد لحظه ای</h3>
        </header>
        <div id="progressBar">
            <div class="slide-progress"></div>
        </div>
        <div id="suggestion-slider" class="owl-carousel owl-theme">
            <div :class="!suggestedProduct.IsAvailable ? 'filter item discount-box' : 'item discount-box'" v-for="suggestedProduct in suggestedProducts">
                <span class="discount" v-if="suggestedProduct.DiscountPercent != 0 && suggestedProduct.Price != 0 && suggestedProduct.IsAvailable">{{suggestedProduct.DiscountPercent}} %</span>
                <router-link tag="a" :title="suggestedProduct.Name" :to="{ name: 'product' , params: { productId: suggestedProduct.Id , productName: suggestedProduct.Name.replace(/\s+/g, '-') } }">
                    <img :src="suggestedProduct.PicPath" class="w-100" :alt="suggestedProduct.ShortName.replace(/\s+/g, '-') + ' ' +  suggestedProduct.Name.replace(/\s+/g, '-')" :title="suggestedProduct.Name.replace(/\s+/g, '-')" @error="imageLoadOnError">
                </router-link>
                <h3 class="product-title">
                    <router-link tag="a" :title="suggestedProduct.Name" :to="{ name: 'product' , params: { productId: suggestedProduct.Id , productName: suggestedProduct.Name.replace(/\s+/g, '-') } }"> {{ suggestedProduct.Name }} </router-link>
                </h3>
                <div class="price"  > 
                    <div v-if="!suggestedProduct.IsAvailable">
                        <span class="unAvailable">ناموجود</span>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            suggestedProducts() {
                return this.$store.getters.readSuggestedProducts;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .widget-suggestion {
       height:100%;
    }
    .discount-box {
        position: relative;
    }

        .discount-box .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 9999;
            font-size: 16px;
        }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }
    }
</style>